import { Component, AfterViewInit } from '@angular/core';
// declare var $:any;
import * as $ from 'jquery';

@Component({
  selector: 'app-not-found',
  templateUrl: './download-expired-component.html',
  styleUrls: ['download-expired-component.css']
})
export class DownloadExpiredComponent implements AfterViewInit {
  ngAfterViewInit() {
    $(function() {
      $('.preloader').fadeOut();
    });
  }
}
